import Cookies from "js-cookie"

import { PREFERRED_CURRENCY_EXPIRATION_DAYS } from "common/consts/cookies"
import initKeyBindings from "../../../app/scripts/tools/initKeyBindings"
import initUrlModals from "../../../app/scripts/tools/initUrlModals"
import { initWindowBindings } from "../../../app/scripts/tools/windowBindings"

export default function subscribeStore(store) {
  let currency
  store.subscribe(() => {
    const previousCurrency = currency
    currency = store.getState().options.get("currency")
    if (previousCurrency !== currency) {
      Cookies.set("preferred_currency", currency, {
        ...Skypicker.cookieOptions,
        expires: PREFERRED_CURRENCY_EXPIRATION_DAYS,
      })
    }
  })

  initKeyBindings(store)
  initUrlModals(store)
  initWindowBindings(store)
}
